/**
 * useFiles
 *
 * Provides a fileUrl() helper that builds a full Directus asset URL.
 * Accepts a file id string or an object with an id property.
 */
import type { File } from '~/types';

export default function useFiles() {
  const config = useRuntimeConfig();

  function fileUrl(fileId: string | File | { id: string } | undefined | null): string | undefined {
    if (!fileId) return undefined;

    if (typeof fileId === 'string') {
      return `${config.public.directus.rest.baseUrl}/assets/${fileId}`;
    }

    if (typeof fileId === 'object' && 'id' in fileId) {
      return `${config.public.directus.rest.baseUrl}/assets/${(fileId as { id: string }).id}`;
    }

    return undefined;
  }

  return { fileUrl };
}
